import React from 'react';
import { graphql } from 'gatsby';
import { TickList as TickListComponent } from '../../../tickList/TickList';

export const TickList = ({ data, ...rest }) => {
  const reshapedList = [];

  if (data?.items?.length > 0) {
    for (let i = 0; i < data.items.length; i++) {
      reshapedList.push(data.items[i].label);
    }
  }

  data.items = reshapedList;

  return <TickListComponent {...data} {...rest} />;
};

export const TickListQuery = graphql`
  fragment TickList on UMBRACO_TickListComponentType {
    items {
      label
    }
  }
`;
